import { render, staticRenderFns } from "./Learner.vue?vue&type=template&id=7ca85372&"
import script from "./Learner.vue?vue&type=script&lang=js&"
export * from "./Learner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca85372')) {
      api.createRecord('7ca85372', component.options)
    } else {
      api.reload('7ca85372', component.options)
    }
    module.hot.accept("./Learner.vue?vue&type=template&id=7ca85372&", function () {
      api.rerender('7ca85372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Learner.vue"
export default component.exports